import styled from 'styled-components';
import { Alert, AlertProps } from '@mui/material';

const Wrapper = styled(Alert)`
  width: 100%;
  height: 48px;

  &.MuiAlert-root {
    color: ${({ theme }) => theme.palette.content.primary};
    border-radius: 0;
  }

  ${({ theme }) => {
    const { bottomBorder } = theme.tokens.components.alert.page;
    return bottomBorder
      ? `&.MuiAlert-root { border-width: 0 0 ${bottomBorder}; }`
      : '';
  }}
`;

const PageAlert = (props: AlertProps) => <Wrapper {...props} />;

export default PageAlert;
